import React, { useEffect } from 'react'
import IdeaPanel from '../../components_newui/idea_panel/View'
import noDraftIdeasImg from '../../img/no_draft_idea.png'
  
export const EvaluationMyIdeaHistory = (props)=>{

    const  {getEvaluationDashboadInnovateMyIdeaHistoryFn,classes,userEmail,isEvaluator,getMyEvaluationDashboardIdeaHistoryIsLoading,getMyEvaluationDashboardIdeaHistory} = props || {}

    useEffect(()=>{
        if(userEmail){
            getEvaluationDashboadInnovateMyIdeaHistoryFn?.(userEmail)
        }
    },[userEmail])


const cleanedData = getMyEvaluationDashboardIdeaHistory?.filter(
    item => item && typeof item === 'object' && Object.keys(item).length > 0
  ) || [];

if(getMyEvaluationDashboardIdeaHistoryIsLoading){
    return 'loading...'
}


    return(
        cleanedData.length > 0 ? (
            <div className={classes.wrp2cols}>
                {
                    cleanedData
                    ?.slice()
                    ?.sort((a, b) => {
                        const timeB = b?.created ? new Date(b?.created)?.getTime() : 0;
                        const timeA = a?.created ? new Date(a?.created)?.getTime() : 0;
                        return timeB - timeA;
                    })
                    ?.map((idea) => {
                        if (!idea?.id) return null;
                        return (
                            <IdeaPanel 
                                key={idea.id} 
                                urlId={idea.id} 
                                idea={idea} 
                                isInnovate={idea?.isInnovate}  
                            />
                        );
                    })
                }
            </div>
        ) :
            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                <img src={noDraftIdeasImg} className={classes.no_idea_img} style={{ maxWidth: '400px' }} alt="no idea found" />
                <div className={classes.no_idea_title}>
                    No evaluation history found
                </div>
            </div>
    )
}

